// extracted by mini-css-extract-plugin
export default {"content":"GettingStarted_content__lJD8w","command":"GettingStarted_command__QZlcq","group":"GettingStarted_group__zudiE"};